jQuery(function ($) {
  setTimeout(() => {
    $(".section-loading").fadeOut("slow");
  }, 4000);

  setTimeout(() => {
    $("body").removeClass("overflow-hidden");
  }, 4000);

  setTimeout(() => {
    $(".container-logo").addClass("logo-active");
  }, 800);
});
